<template>
  <div class="filter">
    <div class="label-title">
      {{ $t('view-Search.filter-title.language') }}
    </div>
    <div class="d-flex justify-content-between">
      <filter-select
        v-model="language"
        field-name="language"
        :placeholder="$t('view-Search.filter.language.placeholder')"
        :image="$publicPath + 'img/search-icon/language.svg'"
        :options-list="$store.state.search.filtersData.languages"
      />
    </div>
  </div>
</template>

<script>
import FilterSelect from '../FilterSelect'

export default {
  components: {
    'filter-select': FilterSelect
  },
  props: {
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    language: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  created () {
    const languages = this.$store.state.search.filtersData.languages
    if (!languages || Object.keys(languages).length === 0) {
      this.$store.dispatch('search/getFiltersData').catch(e => {})
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
